module.exports = __webpack_public_path__ + "static/media/partner04.162b7f66.svg";